<template>
  <div>
    <search-finance-ledger-transfers @submit="submitSearch" />

    <div class="simiot-table-operation-buttons">
      <a-space>
        <a-button
          v-if="isShowMenu('finance_ledger/transfers/export')"
          type="primary"
          @click="exportData"
        >
          导出
        </a-button>
      </a-space>
    </div>

    <a-table
      size="middle"
      :scroll="{ x: 1600 }"
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :pagination="false"
      row-key="id"
    >
      <img
        slot="payorderpic"
        slot-scope="text, record"
        v-if="record.pay_order_url"
        :src="record.pay_order_url"
        style="width:50px;"
        alt=""
        @click="handlePreview(record.pay_order_url)"
      >
    </a-table>

    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />

    <preview-image
      :visible.sync="previewVisible"
      :image.sync="previewImage"
    />
  </div>
</template>

<script>
import { hasPermission } from '@/utils/permission'
import SearchFinanceLedgerTransfers from '@/views/finance_ledger/SearchTransfers'
import Pagination from '@/components/Pagination'
import PreviewImage from '@/components/PreviewImage'
import { findFinanceLedgerTransfers, exportFinanceLedgerTransfers } from '@/api/finance_ledger'
import { exportExcel } from '@/api/excel'
import { formatCurrency } from '@/utils/filter'

export default {
  name: 'FinanceLedgerTransfers',
  components: {
    SearchFinanceLedgerTransfers,
    Pagination,
    PreviewImage
  },
  data() {
    return {
      data: [],
      loading: true,
      previewVisible: false,
      previewImage: '',
      pagination: {
        total_count: 0
      },
      query: {}
    }
  },
  computed: {
    columns() {
      return [
        {
          title: '事件批次',
          width: 100,
          dataIndex: 'no'
        },
        {
          title: '收付款日期',
          width: 120,
          dataIndex: 'paid_at'
        },
        {
          title: '收付款类型',
          width: 100,
          dataIndex: 'transfer_type'
        },
        {
          title: '金额(元)',
          width: 100,
          customRender: formatCurrency,
          dataIndex: 'amount'
        },
        {
          title: '支付方式',
          width: 100,
          dataIndex: 'pay_way'
        },
        {
          title: '支付凭据',
          width: 100,
          dataIndex: 'pay_order_url',
          scopedSlots: { customRender: 'payorderpic' }
        },
        {
          title: '客户名称',
          width: 140,
          ellipsis: true,
          dataIndex: 'agent_name'
        },
        {
          title: '操作人',
          width: 100,
          dataIndex: 'operator_name'
        },
        {
          title: '备注',
          ellipsis: true,
          width: 200,
          dataIndex: 'remark'
        },
        {
          title: '记录时间',
          width: 170,
          dataIndex: 'created_at'
        }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    isShowMenu(menu) {
      return hasPermission(menu)
    },

    submitSearch(search) {
      this.query = Object.assign({},
        this.$options.data().query,
        { per_page: this.query.per_page },
        search)
      this.fetchData()
    },

    fetchData() {
      this.loading = true
      findFinanceLedgerTransfers(this.query).then((res) => {
        if (res.code === 0) {
          this.data = res.data
          this.pagination = res.pagination
        }
        this.loading = false
      })
    },

    handlePreview(imageURL) {
      this.previewImage = imageURL
      this.previewVisible = true
    },

    exportData() {
      exportFinanceLedgerTransfers(this.query).then((res) => {
        if (res.code === 0 && res.data.is_direct_download === true) {
          exportExcel(res.data.id, res.data.file_name)
        }
      })
    }
  }
}
</script>
